export class Serie {
    key: string;

    constructor(key: string) {
        this.key = key;
    }
}
